<template>
    <div class="modal fade model-modal-details ignoreModalIdHash" id="modal_model_details" tabindex="-1" role="dialog"
         aria-hidden="true">
        <div class="modal-dialog modal-dialog--fullscreen" role="document">
            <div class="dismiss-modal-btn" data-dismiss="modal" aria-label="Close">
                <i class="fad fa-times-circle"></i>
            </div>
            <div class="modal-content modal-content--tall">
                <section :class="{
                        'general-detail-section': true,
                        'model-modal-footer-spacer': true,
                        'pb-0': showLoading,
                     }">
                    <div class="section-loading-screen" v-if="showLoading">
                        <div class="section-loading-bubbles">
                            <span class="d1"></span>
                            <span class="d2"></span>
                            <span class="d3"></span>
                            <span class="d4"></span>
                        </div>
                    </div>
                    <div class="container-fluid" v-if="model">
                        <div class="row general-box">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-12 model-heading-wrapper">
                                <div class="mb-3 model-heading u-align-start-mobile">
                                    <i class="fad fa-layer-group"></i>
                                    <h1>
                                        {{ model.rooms_count ? model.rooms_count.name +', ' : ''}}
                                        tip {{ model.model_type }}
                                        <span class="secondary">– {{ project.name }}, {{ project.city.name }}</span>
                                    </h1>
                                </div>
                            </div>
                            <div class="col-xl-3 col-lg-3 d-none d-md-block">
                                <div class="pp-model-modal-actions">
                                    <a href="javascript:void(0)" class="pp-model-modal-contact" @click="openPublicContactModalProject(project,model)"  v-if="canContact">
                                        Contactează dezvoltatorul
                                    </a>
                                    <div class="dropdown-button-wrapper">
                                        <button class="dropdown-button general-btn ghost-btn pp-model-modal-share" name="button" @click="shareDropdown = !shareDropdown">
                                            <span> Distribuie </span>
                                            <i class="fad fa-share"></i>
                                        </button>
                                        <div class="element-dropdown">
                                            <!-- <div class="element-floating-menu" >
                                                
                                            </div> -->
                                            <ul
                                                class="actions-dropdown actions_dropdown_active"
                                                v-if="shareDropdown"
                                                ref="dropdown">
                                                <li>
                                                    <i class="fad fa-copy"></i>
                                                    <a href="javascript:void(0)" class="general-link" @click="copyLink(model,'model')">Copy link </a>
                                                </li>
                                                <li>
                                                    <i class="fab fa-whatsapp"></i>
                                                    <a :href="`https://api.whatsapp.com/send?text=${fullModelUrl}`" class="general-link" target="_blank">Share Whatsapp</a>
                                                </li>
                                                <li>
                                                    <i class="fab fa-facebook-square"></i>
                                                    <a :href="`https://www.facebook.com/sharer/sharer.php?u=${fullModelUrl}`" class="general-link" target="_blank">Share Facebook</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div v-if="isFavorite" class="pp-model-modal-fav" @click="deleteFavoriteModel(model.id)">
                                        Salvat la favorite <i class="fas fa-heart u-color-danger"></i>
                                    </div>
                                    <div v-else class="pp-model-modal-fav" @click="saveFavoriteModel(model.id, model.project_id)">
                                        Salvează la favorite <i class="fas fa-heart"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12 element-body">
                                <div class="mt-3 tab-content" id="tabsContent">
                                    <div class="tab-pane custom-tab-panel fade categories-tabs-wrapper show active" id="modelDetails"
                                         role="tabpane" aria-labelledby="modelDetails">
                                        <div class="row">
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-12 mgb-3">
                                                <div class="project-model-gallery">
                                                    <div class="detail-gallery-container">
                                                        <div class="swiper-container gallery-top model-gallery-top">
                                                            <div class="swiper-wrapper pp-model-gallery">

                                                                <a :href="image" v-for="(image, index) in images" :key="`img-${index}`" class="swiper-slide"
                                                                    :style="{ backgroundImage: 'url(' + image + ')' }">
                                                                    <img style="display: none;" :src="image" alt="">
                                                                </a>

                                                                <a v-for="(video, index) in model.videos" :href="video.link" class="swiper-slide"  :key="index">
                                                                    <h6> {{video.name}} </h6>
                                                                    <div class="swiper-video-box">
                                                                        <object :data="displayVideo(video.link)" class="video_object"></object>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <!-- Add Arrows -->
                                                            <div class="swiper-button-next model-swiper-button-next swiper-button-white"></div>
                                                            <div class="swiper-button-prev model-swiper-button-prev swiper-button-white"></div>
                                                        </div>
                                                        <div class="gallery-content-info">
                                                            <div class="gallery-content-cell" @click="modelGoToSlide(0)">
                                                                <i class="fad fa-images"></i>
                                                                <p> Poze </p>
                                                                <span> ({{images.length}}) </span>
                                                            </div>
                                                            <div class="gallery-content-cell" @click="modelGoToSlide(images.length)">
                                                                <i class="fad fa-video"></i>
                                                                <p> Video </p>
                                                                <span> ({{model.videos.length}}) </span>
                                                            </div>
                                                        </div>
                                                        <div class="swiper-container gallery-thumbs model-gallery-thumbs">
                                                            <div class="swiper-wrapper">
                                                                <div class="swiper-slide kitchen"
                                                                     v-for="(image, index) in thumbs" :key="`img-${index}`"
                                                                     :style="{ backgroundImage: 'url(' + image + ')' }"
                                                                ></div>
                                                                <div class="swiper-slide"  v-for="(video, index) in model.videos" :key="index">
                                                                    <div class="video-thumb">
                                                                        <i class="fad fa-video"></i>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="model-thumbs-button-next swiper-button-next swiper-button-white"></div>
                                                            <div class="model-thumbs-button-prev swiper-button-prev swiper-button-white"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                                                <h3 class="modal-secondary-heading"> Detalii </h3>
                                                <div class="model-modal__details">
                                                    <div class="model-modal__group">
                                                        <div class="model-modal__surface" v-if="model.useful_surface">
                                                            Supr. totala: <span>{{model.useful_surface}} mp</span>
                                                        </div>
                                                        <div class="model-modal__price">
                                                            Pret de la
                                                            <div class="model-modal__price-value" v-if="model.total_items > 0 && model.total_items === model.items_sold">
                                                                --
                                                            </div>
                                                            <div class="model-modal__price-value" v-else>
                                                                {{ formatPrice(model.min_price) }} <span>{{model.price_with_vat ? 'TVA inclus' : '+TVA'}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="model-modal__group">
                                                        <div class="model-modal__surface" v-if="model.terrace_surface">
                                                            Balcon: <span>{{model.terrace_surface}} mp</span>
                                                        </div>
                                                        <div class="model-modal__surface model-modal__surface--empty" v-else></div>
                                                        <div class="model-modal__price" v-if="model.credit_price">
                                                            Pret cu credit de la
                                                            <div class="model-modal__price-value" v-if="model.total_items > 0 && model.total_items === model.items_sold">
                                                                --
                                                            </div>
                                                            <div class="model-modal__price-value" v-else>
                                                                {{ formatPrice(model.min_credit_price) }} <span>{{model.credit_price_with_vat ? 'TVA inclus' : '+TVA'}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div class="model-availability"
                                                     v-if="!hasAccessToProjectItems">
                                                    <div v-if="model && model.type === 'apartment'">
                                                        <div class="unavailable-color" v-if="model.total_items > 0 && model.total_items === model.items_sold">
                                                            <h5> Vandut </h5>
                                                            <p> Acest tip de apartament este vandut </p>
                                                        </div>
                                                        <div class="available-color" v-else-if="buildingsAndApartments && buildingsAndApartments.length > 0">
                                                            <h5> Disponibil </h5>
                                                            <p v-if="1 <= model.available_items && model.available_items <= 3">
                                                                <span v-if="model.available_items > 1">
                                                                    Ultimele {{ model.available_items }} oferte disponibile
                                                                </span>
                                                                <span v-else>
                                                                    Ultima oferta disponibila
                                                                </span>
                                                            </p>
                                                            <p v-else> Acest tip de apartament este disponibil </p>
                                                        </div>
                                                        <div class="unavailable-color" v-else>
                                                            <h5> Indisponibil </h5>
                                                            <p> Acest tip de apartament nu este disponibil </p>
                                                        </div>
                                                    </div>
                                                    <div v-if="model && model.type === 'commercial'">
                                                        <div class="unavailable-color" v-if="model.total_items > 0 && model.total_items === model.items_sold">
                                                            <h5> Vandut </h5>
                                                            <p> Acest tip de spațiu comercial este vandut </p>
                                                        </div>
                                                        <div class="available-color" v-else-if="buildingsAndApartments && buildingsAndApartments.length > 0">
                                                            <h5> Disponibil </h5>
                                                            <p v-if="1 <= model.available_items && model.available_items <= 3">
                                                                <span v-if="model.available_items > 1">
                                                                    Ultimele {{ model.available_items }} oferte disponibile
                                                                </span>
                                                                <span v-else>
                                                                    Ultima oferta disponibila
                                                                </span>
                                                            </p>
                                                            <p v-else> Acest tip de spațiu comercial este disponibil </p>
                                                        </div>
                                                        <div class="unavailable-color" v-else>
                                                            <h5> Indisponibil </h5>
                                                            <p> Acest tip de spațiu comercial nu este disponibil </p>
                                                        </div>
                                                    </div>
                                                    <div v-if="model && model.type === 'house'">
                                                        <div class="unavailable-color" v-if="model.total_items > 0 && model.total_items === model.items_sold">
                                                            <h5> Vandut </h5>
                                                            <p> Acest tip de casa este vandut </p>
                                                        </div>
                                                        <div class="available-color" v-else-if="model.items.length > 0">
                                                            <h5> Disponibil </h5>
                                                            <p v-if="1 <= model.available_items && model.available_items <= 3">
                                                                <span v-if="model.available_items > 1">
                                                                    Ultimele {{ model.available_items }} oferte disponibile
                                                                </span>
                                                                <span v-else>
                                                                    Ultima oferta disponibila
                                                                </span>
                                                            </p>
                                                            <p v-else> Acest tip de casa este disponibil </p>
                                                        </div>
                                                        <div class="unavailable-color" v-else>
                                                            <h5> Indisponibil </h5>
                                                            <p> Acest tip de casa nu este disponibil </p>
                                                        </div>
                                                    </div>

                                                    <div class="unavailable-color mt-3"
                                                         v-if="model.items_sold_today || model.items_sold_yesterday || model.items_sold_recently">
                                                        <p>
                                                            <span v-if="model.items_sold_today">
                                                                {{ model.items_sold_today }}
                                                                {{ model.items_sold_today === 1 ? 'ofertă vândută azi' : 'oferte vândute azi' }}
                                                            </span>
                                                                                    <span v-else-if="model.items_sold_yesterday">
                                                                {{ model.items_sold_yesterday }}
                                                                {{ model.items_sold_yesterday === 1 ? 'ofertă vândută ieri' : 'oferte vândute ieri' }}
                                                            </span>
                                                                                    <span v-else>
                                                                {{ model.items_sold_recently }}
                                                                {{ model.items_sold_recently === 1 ? 'ofertă vândută recent' : 'oferte vândute recent' }}
                                                            </span>
                                                        </p>
                                                    </div>

                                                    <div class="model-modal__spacer"></div>
                                                </div>


                                                 <div
                                                    :class="['model-modal__description', {'model-modal__description--active': showFullDescription}]"
                                                    v-if="model.description"
                                                >
                                                    <h3 class="modal-secondary-heading p-0"> Descriere oferta </h3>
                                                    <div class="model-modal__description-text" v-html="model.description"></div>
                                                    <div class="mt-3 model-modal__description-payment" v-if="model.show_payment_methods">
                                                        <h3 class="modal-secondary-heading p-0"> Modalitate Plata </h3>
                                                        <div class="modal-body-text p-0" v-html="project.payment_method"></div>
                                                    </div>
                                                </div>
                                                <div class="model-modal__description-button" v-if="!showFullDescription && showDescriptionToggle" @click="toggleDescription">
                                                    <div class="model-modal__description-mask"></div>
                                                    <span>
                                                        vezi mai mult <i class="fas fa-chevron-down"></i>
                                                    </span> 
                                                </div>
                                                <div class="model-modal__description-button model-modal__description-button--active" v-else-if="showFullDescription && showDescriptionToggle" @click="toggleDescription">
                                                    <span>
                                                        vezi mai putin <i class="fas fa-chevron-up"></i>
                                                    </span> 
                                                </div>
                                                <div v-else-if="model.show_payment_methods">
                                                    <h3 class="modal-secondary-heading"> Modalitate Plata </h3>
                                                    <div class="modal-body-text" v-html="project.payment_method"></div>
                                                </div>
                                                <div class="model-modal__spacer"></div>
                                            </div>
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-12 mgb-3 model-modal__mobile-offers"
                                                 v-if="hasAccessToProjectItems && buildingsAndApartments && buildingsAndApartments.length > 0 && model.type !== 'house'">
                                                <h3 class="modal-secondary-heading" v-if="model && model.type == 'apartment'"> Acest tip de apartament este disponibil în: </h3>
                                                <h3 class="modal-secondary-heading" v-else-if="model && model.type == 'commercial'"> Acest tip de spațiu comercial este disponibil în: </h3>
                                                <div
                                                    class="model-modal__building"
                                                    v-for="(building, i) in buildingsAndApartments"
                                                    :key="i"
                                                >
                                                    <div
                                                        class="model-modal__building-header"
                                                        role="button"
                                                        data-toggle="collapse"
                                                        :data-target="`#building-levels-${building.id}`"
                                                        aria-expanded="false"
                                                        :aria-controls="`#building-levels-${building.id}`">
                                                        <div class="model-modal__building-meta">
                                                            <div class="model-modal__building-name">
                                                                Bloc {{building.name}} <span v-if="building.finalized_date">- {{building.finalized_date}}</span>
                                                            </div>
                                                            <div class="model-modal__building-offers">
                                                                {{building.apartments.length}} oferte disponibile
                                                            </div>
                                                        </div>
                                                        <div class="model-modal__building-toggle">
                                                            <span>Vezi etaje disponibile<i class="fas fa-chevron-down"></i></span>
                                                            <span>Restrange <i class="fas fa-chevron-up"></i></span>
                                                        </div>
                                                        <div class="model-modal__building-toggle model-modal__building-toggle--mobile">
                                                            <span>Vezi etaje <i class="fas fa-chevron-down"></i></span>
                                                            <span>Restrange <i class="fas fa-chevron-up"></i></span>
                                                        </div>
                                                    </div>
                                                    <div class="model-modal__building-levels collapse" :id="`building-levels-${building.id}`">
                                                        <div class="model-modal__desktop-item-tags">
                                                            <span>
                                                                Etaj / Nr. ap.
                                                            </span>
                                                            <span>
                                                                Suprafață
                                                            </span>
                                                            <span>
                                                                Preț
                                                            </span>
                                                            <span>
                                                                Preț cu credit
                                                            </span>
                                                            <span>
                                                                Status
                                                            </span>
                                                        </div>
                                                        <div class="model-modal__items">
                                                            <div
                                                                class="model-modal__desktop-item"
                                                                v-for="(item, k) in building.apartments"
                                                                :key="k"
                                                            >
                                                                <div class="model-modal__desktop-item-number">
                                                                    <span>
                                                                        {{item.level.name}}
                                                                    </span>
                                                                    <span v-if="item.apartment_number">
                                                                        / Ap. {{item.apartment_number}}
                                                                    </span>
                                                                    <span v-else>
                                                                        / Ap. -
                                                                    </span>
                                                                </div>
                                                                <div class="model-modal__desktop-item-surface">
                                                                    <div>
                                                                        {{item.useful_surface}} m<sup>2</sup> <span>(totala)</span>
                                                                    </div>
                                                                    <div v-if="item.terrace_surface">
                                                                        {{item.terrace_surface}} m<sup>2</sup> <span>(balcon)</span>
                                                                    </div>
                                                                </div>
                                                                <div class="model-modal__desktop-item-price" v-if="item.status == 'available'">
                                                                    <div>
                                                                        {{formatPrice(item.price)}}
                                                                    </div>
                                                                    <div>
                                                                        {{ item.price_with_vat ? 'TVA inclus' : '+TVA'}}
                                                                    </div>
                                                                </div>
                                                                <div class="model-modal__desktop-item-price" v-else>
                                                                    <div>
                                                                        -
                                                                    </div>
                                                                </div>
                                                                <div class="model-modal__desktop-item-price model-modal__desktop-item-price--credit" v-if="item.credit_price && item.status == 'available'">
                                                                    <div>
                                                                        {{formatPrice(item.credit_price)}}
                                                                    </div>
                                                                    <div>
                                                                        {{ item.credit_price_with_vat ? 'TVA inclus' : '+TVA'}}
                                                                    </div>
                                                                </div>
                                                                <div class="model-modal__desktop-item-price model-modal__desktop-item-price--credit" v-else>
                                                                    <div>
                                                                        -
                                                                    </div>
                                                                </div>
                                                                <div v-if="item.status === 'available'" class="model-modal__desktop-item-status model-modal__desktop-item-status--available">
                                                                    Disponibil
                                                                </div>
                                                                <div v-else class="model-modal__desktop-item-status model-modal__desktop-item-status--sold">
                                                                    Vandut
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="model-modal__items model-modal__items--mobile">
                                                            <div class="model-modal__level" v-for="(item, j) in building.apartments" :key="j">
                                                                <div
                                                                    class="model-modal__level-header"
                                                                    role="button" data-toggle="collapse"
                                                                    :data-target="`#building-apartment-${item.id}`"
                                                                    aria-expanded="false"
                                                                    :aria-controls="`#building-apartment-${item.id}`"
                                                                >
                                                                    <div class="model-modal__level-number">
                                                                        {{item.level.name}} 
                                                                        <div class="model-modal__level-apartment">
                                                                            / Ap. <span v-if="item.apartment_number">{{item.apartment_number}}</span><span v-else>-</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="model-modal__level-price">
                                                                        <span>{{ formatPrice(item.price) }}</span> {{item.price_with_vat ? 'TVA inclus' : '+TVA'}}
                                                                    </div>
                                                                    <div class="model-modal__level-toggle">
                                                                        <i class="fas fa-chevron-down"></i>
                                                                        <i class="fas fa-chevron-up"></i>
                                                                    </div>
                                                                </div>
                                                                <div class="model-modal__level-details collapse" :id="`building-apartment-${item.id}`">
                                                                    <div class="model-modal__level-detail">
                                                                        <div class="model-modal__level-value" v-if="item.credit_price">
                                                                            Pret cu credit:
                                                                        </div>
                                                                        <div class="model-modal__level-value">
                                                                            Supr. totala: <span>{{item.useful_surface}} m<sup>2</sup></span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="model-modal__level-detail">
                                                                        <div class="model-modal__level-value" v-if="item.credit_price">
                                                                            <span>{{ formatPrice(item.credit_price) }}</span> {{item.credit_price_with_vat ? 'TVA inclus' : '+TVA'}}
                                                                        </div>
                                                                        <div class="model-modal__level-value">
                                                                            Balcon: <span>{{item.terrace_surface}} m<sup>2</sup></span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="model-modal__sold" v-if="building.soldApartments > 0">
                                                            {{building.soldApartments}} oferte vandute din acest model
                                                        </div>
                                                        <div class="model-modal__finish-date" v-if="building.finalized_date">
                                                            Termen de finalizare: {{building.finalized_date}}
                                                        </div>
                                                        <div class="model-modal__floors-container">
                                                            Etaje bloc: {{building.levels}}
                                                        </div>
                                                        <a
                                                            :href="`${project.buildingsUrl}#b-${building.id}`"
                                                            class="model-modal__building-link"
                                                            v-if="showBuildingsPageLink"
                                                        >
                                                            Vezi lista cu toate ofertele din acest bloc ({{building.all_items_count}})
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="w-100" v-if="hasAccessToProjectItems && model.type === 'house' && model.items.length > 0">
                                                <div class="model-modal__house-header">
                                                    <h3 class="modal-secondary-heading"> Disponibilitate la acest tip de casa: </h3>
                                                    <div class="model-modal__house-counter" v-if="!showOnlyAvailableHouses" @click="showOnlyAvailableHouses = true">
                                                        {{houseOffers}} oferte disponibile
                                                    </div>
                                                    <div class="model-modal__house-counter" v-if="showOnlyAvailableHouses" @click="showOnlyAvailableHouses = false">
                                                        Toate ofertele
                                                    </div>
                                                </div>
                                                <div class="pdetail-levels-container levels-container w-100 model-modal__houses">
                                                    <div class="single-level-row pdetail-level-row"
                                                        :class="[item.status !== 'available' ? 'highlighted-row-unavailable' : 'highlighted-row-available', {'d-none': item.status !== 'available' && showOnlyAvailableHouses} ]"
                                                        v-for="(item, itemIndex) in model.items" :key="itemIndex"
                                                    >
                                                        <div class="row">
                                                            <div class="col-xl-2 col-lg-3 col-md-12 col-sm-12">
                                                                <div class="level-item-nr level-strip-cell">
                                                                    <p class="level-cell-heading"> Nr Casa. </p>
                                                                    <p class="highlighted-info-strip"> {{
                                                                        item.apartment_number }} </p>
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-2 col-lg-3 col-md-12 col-sm-12">
                                                                <p class="level-cell-heading"> Suprafata</p>
                                                                <div class="level-item-size level-strip-cell pdetail-level-cell surface-list">
                                                                    <p class="pdetail-surface-type">
                                                                        <span> Totala </span>
                                                                        <span> {{ item.useful_surface }} m² </span>
                                                                    </p>
                                                                    <p class="pdetail-surface-type">
                                                                        <span> Balcon: </span>
                                                                        <span> {{ item.terrace_surface }} m² </span>
                                                                    </p>
                                                                    <p class="pdetail-surface-type">
                                                                        <span> Teren: </span>
                                                                        <span> {{ item.garden_surface }} m² </span>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12">
                                                                <div class="level-item-size level-strip-cell">
                                                                    <p class="level-cell-heading"> Pret </p>
                                                                    <div class="prices-list">
                                                                        <p class="highlighted-info-strip" v-if="item.status !== 'available'"> -- </p>
                                                                        <p class="highlighted-info-strip" v-else>
                                                                            {{ formatPrice(item.price) }}
                                                                            <br>
                                                                            <small>({{item.price_with_vat ? 'TVA inclus' : '+TVA'}})</small>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12">
                                                                <div class="level-item-size level-strip-cell">
                                                                    <p class="level-cell-heading"> Pret cu credit </p>
                                                                    <div class="prices-list">
                                                                        <p class="highlighted-info-strip" v-if="item.status !== 'available' || !item.credit_price"> -- </p>
                                                                        <p class="highlighted-info-strip" v-else>
                                                                            {{ formatPrice(item.credit_price) }}
                                                                            <br>
                                                                            <small>({{item.credit_price_with_vat ? 'TVA inclus' : '+TVA'}})</small>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="ml-auto col-xl-2 col-lg-2 col-md-12 col-sm-12">
                                                                <div class="level-item-size level-strip-cell">
                                                                    <p class="level-cell-heading"> Status </p>
                                                                    <p class="highlighted-info-strip"> {{ item.status
                                                                        === "available" ? "Disponibil" : "Vandut"
                                                                        }} </p>
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12">
                                                                <div class="level-item-size level-strip-cell">
                                                                    <p class="level-cell-heading"> Termen finalizare </p>
                                                                    <p class="highlighted-info-strip"> {{ item.finalized_at ? item.finalized_at : '&#45;&#45;' }} </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-12 mgb-3 d-none d-md-block" v-if="model.video">
                                                <h3 class="modal-secondary-heading"> Video Model </h3>
                                                <div class="project-video-box">
                                                    <object :data="model.video.link" width="560" height="315"></object>
                                                </div>
                                            </div>

                                            <div class="public-project-container">
                                                <div class="project-contact">
                                                    <h2 class="pp-tab-heading"> Contacteaza-ne </h2>
                                                    <p>Afla mai multe detalii sau programeaza o vizionare</p>
                                                    <PublicContactProject
                                                        :project="project"
                                                        user-phone=""
                                                        user-email=""
                                                        prefix="modal">
                                                    </PublicContactProject>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade show" id="model-details-tab-block" role="tabpanel"
                                         aria-labelledby="model-details-tab-block" v-if="activeBuilding">
                                        <div class="pdetail-levels-container levels-container">
                                            <div class="single-level-wrapper" v-for="(level, index) in levels"
                                                 :key="index">
                                                <h3 class="collapse-trigger" data-toggle="collapse"
                                                    :data-target="`#floortarget_${level.level.id}`"
                                                    aria-expanded="false"
                                                    :aria-controls="`floortarget_${level.level.id}`">
                                                    <span>
                                                        {{ level.level.name }}
                                                    </span>
                                                    <i class="fad fa-arrow-alt-circle-up"></i>
                                                </h3>
                                                <div class="collapse-list collapse multi-collapse show"
                                                     :id="`floortarget_${level.level.id}`">
                                                    <div class="single-level-row pdetail-level-row"
                                                         v-for="(item, itemIndex) in level.items" :key="itemIndex"
                                                         :class="item.status !== 'available' ? 'highlighted-row-unavailable' : 'highlighted-row-available'">
                                                        <div class="row">
                                                            <div class="col-xl-2 col-lg-3 col-md-12 col-sm-12">
                                                                <div class="level-item-nr level-strip-cell">
                                                                    <p class="level-cell-heading"> Nr Ap. </p>
                                                                    <p class="highlighted-info-strip"> {{
                                                                        item.apartment_number }} </p>
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12">
                                                                <p class="level-cell-heading"> Suprafata</p>
                                                                <div class="level-item-size level-strip-cell pdetail-level-cell surface-list">
                                                                    <p class="pdetail-surface-type">
                                                                        <span> Totala: </span>
                                                                        <span> {{ item.useful_surface }} m² </span>
                                                                    </p>
                                                                    <p class="pdetail-surface-type">
                                                                        <span> Balcon: </span>
                                                                        <span> {{ item.terrace_surface }} m² </span>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12">
                                                                <div class="level-item-size level-strip-cell">
                                                                    <p class="level-cell-heading"> Pret </p>
                                                                    <p class="highlighted-info-strip" v-if="item.status !== 'available'"> -- </p>
                                                                    <p class="highlighted-info-strip" v-else>
                                                                        {{ formatPrice(item.price) }}
                                                                        <br>
                                                                        <small>({{ item.price_with_vat ? 'TVA inclus' : '+TVA'}})</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12">
                                                                <div class="level-item-size level-strip-cell">
                                                                    <p class="level-cell-heading"> Pret cu credit </p>
                                                                    <p class="highlighted-info-strip" v-if="item.status !== 'available' || !item.credit_price"> -- </p>
                                                                    <p class="highlighted-info-strip" v-else>
                                                                        {{ formatPrice(item.credit_price) }}
                                                                        <br>
                                                                        <small>({{ item.credit_price_with_vat ? 'TVA inclus' : '+TVA'}})</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="ml-auto col-xl-2 col-lg-2 col-md-12 col-sm-12">
                                                                <div class="level-item-size level-strip-cell">
                                                                    <p class="level-cell-heading"> Status </p>
                                                                    <p class="highlighted-info-strip"> {{ item.status
                                                                        === "available" ? "Disponibil" : "Vandut"
                                                                        }} </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade show" id="model-details-tab-house" role="tabpanel"
                                         aria-labelledby="model-details-tab-house" v-if="model.type === 'house'">
                                        <div class="pdetail-levels-container levels-container">
                                            <div class="single-level-row pdetail-level-row"
                                                 :class="item.status !== 'available' ? 'highlighted-row-unavailable' : 'highlighted-row-available'"
                                                 v-for="(item, itemIndex) in model.items" :key="itemIndex">
                                                <div class="row">
                                                    <div class="col-xl-2 col-lg-3 col-md-12 col-sm-12">
                                                        <div class="level-item-nr level-strip-cell">
                                                            <p class="level-cell-heading"> Nr Casa. </p>
                                                            <p class="highlighted-info-strip"> {{
                                                                item.apartment_number }} </p>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-2 col-lg-3 col-md-12 col-sm-12">
                                                        <p class="level-cell-heading"> Suprafata</p>
                                                        <div class="level-item-size level-strip-cell pdetail-level-cell surface-list">
                                                            <p class="pdetail-surface-type">
                                                                <span> Totala </span>
                                                                <span> {{ item.useful_surface }} m² </span>
                                                            </p>
                                                            <p class="pdetail-surface-type">
                                                                <span> Teren: </span>
                                                                <span> {{ item.garden_surface }} m² </span>
                                                            </p>
                                                            <p class="pdetail-surface-type">
                                                                <span> Balcon: </span>
                                                                <span> {{ item.terrace_surface }} m² </span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12">
                                                        <div class="level-item-size level-strip-cell">
                                                            <p class="level-cell-heading"> Pret </p>
                                                            <div class="prices-list">
                                                                <p class="highlighted-info-strip" v-if="item.status !== 'available'"> -- </p>
                                                                <p class="highlighted-info-strip" v-else>
                                                                    {{ formatPrice(item.price) }}
                                                                    <br>
                                                                    <small>({{ item.price_with_vat ? 'TVA inclus' : '+TVA'}})</small>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12">
                                                        <div class="level-item-size level-strip-cell">
                                                            <p class="level-cell-heading"> Pret cu credit </p>
                                                            <div class="prices-list">
                                                                <p class="highlighted-info-strip" v-if="item.status !== 'available' || !item.credit_price"> -- </p>
                                                                <p class="highlighted-info-strip" v-else>
                                                                    {{ formatPrice(item.credit_price) }}
                                                                    <br>
                                                                    <small>({{ item.credit_price_with_vat ? 'TVA inclus' : '+TVA'}})</small>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="ml-auto col-xl-2 col-lg-2 col-md-12 col-sm-12">
                                                        <div class="level-item-size level-strip-cell">
                                                            <p class="level-cell-heading"> Status </p>
                                                            <p class="highlighted-info-strip"> {{ item.status
                                                                === "available" ? "Disponibil" : "Vandut"
                                                                }} </p>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12">
                                                        <div class="level-item-size level-strip-cell">
                                                            <p class="level-cell-heading"> Termen finalizare </p>
                                                            <p class="highlighted-info-strip"> {{ item.finalized_at ? item.finalized_at : '&#45;&#45;' }} </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div class="model-modal-details__footer">
                <div class="model-modal-details__button" @click="openPublicContactModalProject(project,model)" v-if="canContact">
                    <i class="fas fa-phone"></i>
                    Contact
                </div>
                <div v-if="isFavorite" class="model-modal-details__button model-modal-details__button--fav">
                    <i class="fas fa-heart u-color-danger" @click="deleteFavoriteModel(model.id)"></i>
                    Sterge
                </div>
                <div v-else class="model-modal-details__button model-modal-details__button--fav">
                    <i class="fas fa-heart" @click="saveFavoriteModel(model.id, model.project_id)"></i>
                    Salveaza
                </div>
                <div class="model-modal-details__button" @click="shareDropdown = !shareDropdown">
                    <i class="fas fa-share-square"></i>
                    Distribuie
                </div>
                    <div class="element-dropdown">
                        <!-- <div class="element-floating-menu" >
                            
                        </div> -->
                        <ul
                            class="actions-dropdown actions_dropdown_active"
                            v-if="shareDropdown"
                            ref="dropdown">
                            <li>
                                <i class="fad fa-copy"></i>
                                <a href="javascript:void(0)" class="general-link" @click="copyLink(model,'model')">Copy link </a>
                            </li>
                            <li>
                                <i class="fab fa-whatsapp"></i>
                                <a :href="`https://api.whatsapp.com/send?text=${fullModelUrl}`" class="general-link" target="_blank">Share Whatsapp</a>
                            </li>
                            <li>
                                <i class="fab fa-facebook-square"></i>
                                <a :href="`https://www.facebook.com/sharer/sharer.php?u=${fullModelUrl}`" class="general-link" target="_blank">Share Facebook</a>
                            </li>
                        </ul>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
  import Swiper from 'swiper/bundle';
  import PublicContactProject from "./PublicContactProject";

  export default {
    name: "PublicProjectModelDetails",
    components: { PublicContactProject},
    props: {
        favProjects: {
            type: String,
            default: null
        },
        userId: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
        showLoading: false,
        galleryInitiated: false,
        modelGalleryThumbs: null,
        modelGalleryTop: null,
        model: null,
        project: null,
        images: null,
        thumbs: null,
        activeBuilding: null,
        from: '',
        isAvailabilityTab: false,
        buildingsFilterFirst: {},
        buildings: null,
        isAgent: false,
        canContact: false,
        isFavorite: false,
        favorites: null,
        shareDropdown: false,
        deletedFavorite: false,
        hasPayLoad: false,
        showFullDescription: true,
        buildingsAndApartments: null,
        descriptionHeightSet: false,
        showDescriptionToggle: false,
        showOnlyAvailableHouses: false,
        hasAccessToProjectItems: false,
        fullModelUrl: null
      }
    },
    async mounted() {
      let vm = this
      $('#modal_model_details').on('shown.bs.modal', function() {
          setTimeout(() => {
                if(!vm.hasPayLoad)
                {
                    let url = window.location.href;
                    url = url.substr(0, url.lastIndexOf('#'));
                    window.location.href = url;
                    return;
                }
            }, 100);

          const intervalId = setInterval(() => {
              if (!vm.model) {
                  return;
              }

              let modal = this;
              let hash = window.getModelHashTagWithType(vm.model);

              window.location.hash = hash;
              window.onhashchange = function() {
                  let modalHash = '#' + hash;

                  if (window.location.hash !== modalHash) {
                      $(modal).modal('hide');
                  } else {
                      $(modal).modal('show');
                  }
              }

              // stop the interval
              clearInterval(intervalId);
          }, 10);

            //MAKE MODAL FULLSCREEN ON MOBILE
            if(window.innerWidth <= 768) {
                document.querySelector('#modal_model_details').style.setProperty('padding-right', '0');
                document.querySelector('.modal-dialog--fullscreen').style.setProperty('margin', '0');
                document.querySelector('.modal-dialog--fullscreen').style.setProperty('max-width', '100%', 'important');
            }
      });   
      $('#modal_model_details').on('hidden.bs.modal', function () {
        vm.model = null
        vm.project = null
        vm.buildings = null
        vm.images = null
        vm.thumbs = null
        vm.activeBuilding = null
        vm.from = ''
        vm.buildingsFilterFirst = {}
        vm.isAvailabilityTab = false
        vm.galleryInitiated = false
        vm.showFullDescription = true
        vm.descriptionHeightSet = false
        vm.showDescriptionToggle = false
        vm.buildingsAndApartments = null
        vm.fullModelUrl = null
        vm.shareDropdown = false
        // vm.favorites = null
        if(vm.deletedFavorite)
            vm.$eventBus.$emit('UPDATE_FAVORITES_PAGE')
        document.getElementsByTagName('body')[0].classList.remove('big-overflow');

        // remove hashtag and the # character
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      });
      this.$eventBus.$on('SAVED_FAVORITES', function (payLoad) {
        let fav = payLoad.fav;
        vm.favorites = vm.favorites || [];
        vm.favorites = vm.favorites.concat(fav);
      });
      this.$eventBus.$on('DELETED_FAVORITES_LIST', function (payLoad) {
        if(vm.favorites.length > 0)
        {
          vm.favorites.forEach((fav, key) => {
            if(fav.favoritable_id == payLoad.favId && fav.favoritable_type === 'App\\ProjectModel')
            {
              vm.favorites.splice(key, 1);
              return;
            }
          });
        }
      });
      this.$eventBus.$on('OPEN_MODEL_DETAIL_MODAL', async function (payLoad) {
        
        if(payLoad)
            vm.hasPayLoad = true;

        if(!vm.favorites)
        {
            if(vm.favProjects)
                vm.favorites = JSON.parse(vm.favProjects);
            else
                vm.favorites = window.getLocalFavorites();
        }

        $('#modal_model_details').modal('show');

        await vm.getModelData(payLoad.projectId, payLoad.modelId, payLoad.from, payLoad.isAvailabilityTab, payLoad.buildingsFilterFirst)
        await vm.checkAgent(payLoad.projectId)
        await vm.checkFavoriteModel(payLoad.modelId)
        await vm.checkContact();
        await vm.groupBuildingsAndApartments();
      });
    },
    updated() {
        // console.log(this.descriptionHeightSet);
        this.setMobileDescriptionVisibility();
    },
    computed: {
      levels() {
        let output = []
        if (this.model) {
          for (let i in this.model.items) {
            if (!output[this.model.items[i].level_id]) {
              output[this.model.items[i].level_id] = {
                level: null,
                items: []
              }
            }
            if (
                this.model.items[i].building && this.activeBuilding &&
                this.model.items[i].building.id === this.activeBuilding.id
            ) {
              output[this.model.items[i].level_id].level = this.model.items[i].level
              output[this.model.items[i].level_id].items.push(this.model.items[i])
            }
          }
          output = output.filter(lvl => lvl.items.length > 0);
          output.sort(function(a, b) { return a.level.sort_order - b.level.sort_order});
          return output;
        } else {
          return []
        }
      },
      houseOffers() {
        let availableHouses = 0;
          if(this.model && this.model.type == 'house')
          {
            this.model.items.forEach(item => {
                if(item.status == 'available')
                    availableHouses++;
            });
          }
        return availableHouses;
      },
      showBuildingsPageLink() {
        return window.location.href.split('/')[5] !== 'lista-de-preturi-si-disponibilitati#modal_model_details';
      }
    },

    methods: {
      async getModelData(projectId, modelId, from = '', isAvailabilityTab = false, buildingsFilterFirst = {}) {
        this.showLoading = true;
        this.from = from
        this.isAvailabilityTab = isAvailabilityTab
        this.buildingsFilterFirst = buildingsFilterFirst
        let vm = this
        await window.axios.get(`/ajax/project/${projectId}/model/${modelId}/details`)
          .then(function (resp) {
            vm.model = resp.data.data.model
            vm.project = resp.data.data.project
            vm.buildings = resp.data.data.buildings
            vm.images = resp.data.data.images
            vm.thumbs = resp.data.data.thumbs
            vm.fullModelUrl = window.getFullModelUrl(vm.model);
            vm.hasAccessToProjectItems = resp.data.data.hasAccessToProjectItems

            document.getElementsByTagName('body')[0].classList.add('big-overflow')
            vm.showLoading = false;
            vm.initGallery();
            // console.log(vm.model);
            vm.activeBuilding = buildingsFilterFirst && buildingsFilterFirst.id
                ? vm.model.buildings.find(building => building.id === buildingsFilterFirst.id)
                : vm.activeBuilding = vm.model.buildings[0]
                
            setTimeout(function() {
                const tabIndex = vm.activeBuilding && vm.activeBuilding.id
                    ? vm.buildings.findIndex(building => building.id === vm.activeBuilding.id) + 2
                    : 2
                $('#navTabs li:nth-child(' + tabIndex + ') a').tab('show')
            }, 0)
          })
          .catch(function (err) {
            vm.showLoading = false;
            window.showError(err)
          });
      },
      async checkAgent(projectId) {
        let vm = this
        vm.showLoading = true;
        await window.axios.get(`/ajax/checkAgent/${projectId}`)
          .then(function (resp) {
            vm.isAgent = resp.data.data
            vm.showLoading = false;
          })
          .catch(function () {
              vm.showLoading = false;
          });
      },
        initGallery() {
            // if (this.galleryInitiated) return false
            
            let vm = this
            setTimeout(function(){
                vm.modelGalleryThumbs = new Swiper(`.model-gallery-thumbs`, {
                    spaceBetween: 10,
                  slidesPerView: 5,
                  freeMode: false,
                  watchActiveIndex: true,
                  watchSlidesVisibility: true,
                  watchSlidesProgress: true,
                  navigation: {
                      nextEl: `.model-thumbs-button-next`,
                    prevEl: `.model-thumbs-button-prev`,
                  },
                });

                vm.modelGalleryTop = new Swiper(`.model-gallery-top`, {
                    spaceBetween: 10,
                  watchActiveIndex: true,
                  navigation: {
                    nextEl: `.model-swiper-button-next`,
                    prevEl: `.model-swiper-button-prev`,
                  },
                  thumbs: {
                      swiper: vm.modelGalleryThumbs
                  }
                });

                $(`.pp-model-gallery`).lightGallery({
                    thumbnail:true
                });
            }, 500)
            vm.galleryInitiated = true
        },
        modelGoToSlide(index){
            this.modelGalleryTop.slideTo(parseInt(index), 0);
        },
        getId(url) {
            let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
            let match = url.match(regExp);

            if (match && match[2].length >= 11) {
                return match[2];
            } else {
                return 'error';
            }
        },
        displayVideo(link) {
            let linkId = this.getId(link);
            return "//www.youtube.com/embed/" + linkId
        },
        checkFavoriteModel(modelId) {
            if (this.favorites && this.favorites.length > 0) {
                let exists = this.favorites.filter(favorite => favorite.favoritable_type == 'App\\ProjectModel' && favorite.favoritable_id === modelId)
                this.isFavorite = exists.length > 0
            } else {
                this.isFavorite = false;
            }
        },
        deleteFavoriteModel(id) {
            let vm = this;
            this.isFavorite = false;
            if(vm.favProjects) { // logged in
                window.axios.delete(`/ajax/favorites/${id}/model`)
                    .then(function () {
                        vm.favorites.forEach(function (fav, key) {
                            if (fav.favoritable_type === 'App\\ProjectModel' && fav.favoritable_id === id) {
                                vm.favorites.splice(key, 1);
                                vm.deletedFavorite = true;
                                vm.$eventBus.$emit('DELETED_FAVORITES_MODAL', {
                                    favId: id
                                });
                            }
                        });
                        window.Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            html: 'Modelul a fost sters din lista de favorite.',
                            showConfirmButton: false,
                            timer: 1500
                        })
                    })
                    .catch(function (err) {
                        window.showError(err)
                    });
            } else {
                vm.favorites = vm.favorites.filter(
                    fav => !(
                        fav.favoritable_type === "App\\ProjectModel" &&
                        fav.favoritable_id === id
                    )
                );
                window.saveLocalFavorites(vm.favorites);

                window.Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    html: 'Modelul a fost sters din lista de favorite.',
                    showConfirmButton: false,
                    timer: 1500
                });
            }
        },
        saveFavoriteModel(modelId, projectId)
        {
            this.openAddFavoriteModelModal(modelId, projectId);
            this.isFavorite = true;
        },
        checkContact() {
            if(!this.userId)
                this.canContact = true;
            else
                this.canContact = this.userId !== this.project.user_id;
        },
        groupBuildingsAndApartments() {
            this.buildingsAndApartments = this.buildings;
            this.buildingsAndApartments.forEach(building => {
                building.apartments = [];
                building.soldApartments = 0;
                building.availableApartments = 0;
                let hasPenthouse = false;
                let biggestLevel = "";
                for (let i in this.model.items) {
                    if (
                        this.model.items[i].building &&
                        this.model.items[i].building.id === building.id &&
                        this.model.items[i].status == 'available'
                    )
                        building.apartments.push(this.model.items[i]);
                        building.availableApartments++;
                    if(
                        this.model.items[i].building &&
                        this.model.items[i].building.id === building.id &&
                        this.model.items[i].status == 'sold'
                    )
                        building.soldApartments++;

                    if(this.model.items[i].building && this.model.items[i].building.id === building.id)
                    {
                        if(this.model.items[i].level.name == "Mansarda")
                            hasPenthouse = true;
                        if(
                            biggestLevel.localeCompare(this.model.items[i].level.name) == -1 &&
                            this.model.items[i].level.name != "Parter" &&
                            this.model.items[i].level.name != "Mansarda"
                        )
                            biggestLevel =  this.model.items[i].level.name;
                    }
                }
                building.levels = biggestLevel.split('').pop() + " etaje";
                if(hasPenthouse)
                    building.levels += " + mansarda";
                building.apartments.sort(function(a, b) { return a.level.sort_order - b.level.sort_order});
            });
            // console.log(this.buildingsAndApartments);
        },
        setMobileDescriptionVisibility() {
            if(this.descriptionHeightSet == false)
            {
                let description = document.querySelector('.model-modal__description-text');
                let paymentType = document.querySelector('.model-modal__description-payment');
                if(paymentType != null)
                {
                    if((description.offsetHeight + paymentType.offsetHeight) > 325)
                    {
                        this.showFullDescription = false;
                        this.showDescriptionToggle = true;
                        this.descriptionHeightSet = true;
                    }
                }
                else if(description != null)
                {
                    if(description.offsetHeight > 325)
                    {
                        this.showFullDescription = false;
                        this.showDescriptionToggle = true;
                        this.descriptionHeightSet = true;
                    }
                }
            }
        },
        toggleDescription() {
            this.showFullDescription = !this.showFullDescription;
        }
    }
  }
</script>

<style scoped>
    .model-modal__spacer {
        margin: 30px 0;
    }

    #modal_model_details .public-project-container {
        box-shadow: none;
        padding: 0 15px;
        width: 100%;
    }

    .model-availability {
        padding-top: 15px !important;
    }

    @media (max-width: 768px) {
        .model-availability {
            padding: 0 10px;
        }
    }

    #modelDetails .public-project-container .project-contact {
        margin: 0;
    }

    .model-modal__description {
        max-height: 325px;
    }

    .model-modal__description--active {
        max-height: none;
    }
</style>

